@if(show){

<div class="modal fade show d-block" tabindex="-1">

    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title">
                    {{title}}
                </h5>

                <button
                    type="button"
                    class="btn-close"
                    (click)="close()">
                </button>

            </div>

            <div class="modal-body">

                <p>
                    {{message}}
                </p>

            </div>

            <div class="modal-footer">

                <button
                    class="btn btn-light"
                    (click)="close()">

                    {{cancelText}}

                </button>

                <button
                    class="btn btn-primary"
                    (click)="confirm()">

                    {{confirmText}}

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal-backdrop fade show"></div>

}